module.exports = __webpack_public_path__ + "static/media/carousel6.daceda04.jpeg";